import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Grid } from '@mui/material'

import Dialog from './Dialog'
import GridSelect from './GridSelect'
import GridCheckbox from './GridCheckbox'
import GridInputField from './GridInputField'
import GridCircularProgress from './GridCircularProgress'
import { useGetImpostazioniAlgoritmiQuery } from '../hooks/api-slice'
import { formatBodyField } from '../hooks/utils-functions'
import {
  titlesImpostazioni,
  NOMI_GIRONI,
  NOMI_GIRONI_RESTART,
  NUMERI_GARA,
} from '../settings/settings'
import { setImpostazioniAlgoritmi } from '../container/home'

const DialogImpostazioniAlgoritmi = ({
  open,
  handleClose,
  triggerFunction,
}) => {
  const impostazioniAlgoritmi = useSelector(
    state => state.home.impostazioniAlgoritmi,
  )
  const { data: impoAlgo, isLoading } = useGetImpostazioniAlgoritmiQuery()

  const dispatch = useDispatch()

  useEffect(() => {
    if (open) dispatch(setImpostazioniAlgoritmi(impoAlgo))
  }, [dispatch, impoAlgo, open])

  const cDispatch = (field, value) =>
    dispatch(
      setImpostazioniAlgoritmi({
        ...impostazioniAlgoritmi,
        [field]: formatBodyField(value),
      }),
    )

  const MyGridCheckbox = ({ label, field }) => (
    <GridCheckbox
      label={label}
      field={field}
      value={impostazioniAlgoritmi?.[field]}
      onChange={cDispatch}
      justifyContent='flex-start'
    />
  )

  const MyGridSelect = ({ label, field, options, optionLabels }) => (
    <GridSelect
      label={label}
      field={field}
      value={impostazioniAlgoritmi?.[field]}
      options={options}
      optionLabels={optionLabels}
      onChange={cDispatch}
    />
  )

  const MyGridInputField = (label, field) => (
    <GridInputField
      label={label}
      field={field}
      value={impostazioniAlgoritmi?.[field]}
      onChange={cDispatch}
      type='number'
    />
  )

  const MyTitle = ({ title }) => (
    <Grid size={12} marginTop={2} marginBottom={1}>
      <b>{title}</b>
    </Grid>
  )

  useEffect(() => {
    if (!open) dispatch(setImpostazioniAlgoritmi())
  }, [dispatch, open])

  return (
    <Dialog
      open={open}
      handleClose={handleClose}
      triggerFunction={triggerFunction}
      title={titlesImpostazioni.titleAlgoritmi}
      textConfirm='Salva'
      maxWidth='md'
    >
      {isLoading ? (
        <GridCircularProgress />
      ) : (
        <Grid
          container
          spacing={2}
          paddingTop={1}
          alignItems='center'
          sx={{ width: '100%' }}
        >
          <MyTitle title='Algoritmo Gironi' />
          <MyGridSelect
            label='Nome gironi'
            field='NomiGironi'
            options={NOMI_GIRONI}
          />
          <MyGridSelect
            label='Nomi gironi'
            field='NomiGironiRestart'
            options={NOMI_GIRONI_RESTART}
          />
          {MyGridInputField('Numero di tentativi', 'TENTATIVI')}
          <MyGridCheckbox
            label='Separa squadre stessa società'
            field='SeparateSocietyTeams'
          />
          {MyGridInputField('Peso zone', 'WeightZone')}
          {MyGridInputField('Peso abbinamenti', 'WeightAbb')}
          {MyGridInputField('Peso alternanze', 'WeightAlt')}
          {MyGridInputField('Peso separazioni', 'WeightSep')}
          {MyGridInputField('Peso posizioni', 'WeightOrd')}
          {MyGridInputField('Peso gironi precedenti', 'WeightPre')}
          {MyGridInputField('Peso indisponibilità', 'WeightInd')}
          <MyTitle title='Algoritmo Calendari' />
          {MyGridInputField('Primo numero gara', 'PrimoNumeroGara')}
          {MyGridInputField(
            'Primo numero gara Propaganda',
            'PrimoNumeroGaraPropaganda',
          )}
          <MyGridSelect
            label='Numeri gara'
            field='NumeriGara'
            options={NUMERI_GARA}
          />
        </Grid>
      )}
    </Dialog>
  )
}

export default DialogImpostazioniAlgoritmi
